import React from "react"
import TitleStyled from "./styles/titleStyles"
import LogoNumberStyled from "./styles/LogoNumberStyles.js"
import myInitObject from "../ultis/variable"

const LogoNumber = ({
  heading,
  textLogo,
  textBeforeNumber,
  logo,
  number,
  numberColor,
  textAfterNumber,
}) => {
  return (
    <LogoNumberStyled>
      <div className="container">
        <TitleStyled textAlign="center" linePosition="center" color="#000">
          <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
        </TitleStyled>
        <div className="logoNumber__wrapper">
          <div className="logoNumber__wrapper__logo">
            <TitleStyled textAlign="center" linePosition="center" color="#000">
              <h3 dangerouslySetInnerHTML={{ __html: textLogo }}></h3>
            </TitleStyled>
            <img src={myInitObject.cockpitUrl + logo} alt={textLogo} />
          </div>
          <div className="logoNumber__wrapper__number">
            <TitleStyled textAlign="center" linePosition="center" color="#000">
              <h3 dangerouslySetInnerHTML={{ __html: textBeforeNumber }}></h3>
              <p className="logoNumber__number" style={{ color: numberColor }}>
                {number}
              </p>
              <p className="logoNumber__textAfterNumber">{textAfterNumber}</p>
            </TitleStyled>
          </div>
        </div>
      </div>
    </LogoNumberStyled>
  )
}

export default LogoNumber
